var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65892 16.3495C2.73818 17.7254 3.81614 18.8326 5.1906 18.9329C8.46294 19.1717 11.532 19.1717 14.8044 18.9329C16.1788 18.8326 17.2568 17.7254 17.336 16.3496C17.5636 12.4004 17.5636 8.59985 17.336 4.65067C17.2568 3.27484 16.1788 2.16759 14.8044 2.06729C11.532 1.82848 8.46294 1.82848 5.1906 2.06729C3.81614 2.16759 2.73818 3.27484 2.65892 4.65067C2.4314 8.59985 2.4314 12.4004 2.65892 16.3495Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.43
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4849 8.57441H2.50391C2.5291 7.27571 2.57974 5.9715 2.65584 4.65067C2.7351 3.27484 3.81306 2.16759 5.18752 2.06729C8.45987 1.82848 11.5289 1.82848 14.8013 2.06729C16.1757 2.16759 17.2537 3.27484 17.333 4.65067C17.4091 5.9715 17.4597 7.27571 17.4849 8.57441Z",
    fill: "#0A0C13",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 5.23145H13.837",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.29408,
    cy: 12.1901,
    r: 1.07143,
    fill: "#84C70D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.29408,
    cy: 15.5382,
    r: 1.07143,
    fill: "#84C70D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0011,
    cy: 12.1901,
    r: 1.07143,
    fill: "#84C70D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0011,
    cy: 15.5382,
    r: 1.07143,
    fill: "#84C70D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7042,
    cy: 12.1901,
    r: 1.07143,
    fill: "#84C70D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7042,
    cy: 15.5382,
    r: 1.07143,
    fill: "#84C70D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.4d6e7afa93fb7ed5e1ef20edd80461d1.svg";
export { ForwardRef as ReactComponent };